import React from 'react';
import ReportPage from './components/ReportPage';
import KeysByCompanyByStatusList from './components/KeysByCompanyByStatusList';
import { useAppSelector } from '../../hooks';

function KeysByCompanyByStatus() {
  const currentUser = useAppSelector((state) => state.auth);
  return (
    <ReportPage title="Keys by company by status">
      <KeysByCompanyByStatusList currentUser={currentUser} />
    </ReportPage>
  );
}

export default KeysByCompanyByStatus;
